export function getIdFromDate(date: Date): string {
    const month = date.getMonth() + 1 // JavaScript months are zero-based
    const year = date.getFullYear()

    return year + '-' + month.toString().padStart(2, '0')
}
